/**
 * Where a rendered card's USPs came from.
 */
const UspSource = {
  CLIENT_BRANDS: 'client-brands',
  COMPONENT_GENERIC_USPS: 'component-generic-usps',
  COMPONENT_USPS: 'component-usps',
  NONE: 'none',
};

export default UspSource;
